import { QualificationJSON } from '@scale/shared/types/qualification/types';
import { useMutation, UseMutationResult } from 'react-query';
import apiFetch, { defaultApiFetchErrorHandler, HTTPError } from 'react-scale/lib/api-fetch';

export const useUpdateQualification = (
  onSuccess?: (data: QualificationJSON) => void,
): UseMutationResult<
  QualificationJSON,
  unknown,
  Partial<QualificationJSON> & Pick<QualificationJSON, '_id'>
> => {
  return useMutation(
    ['updateQualification'],
    async (qualification: Partial<QualificationJSON> & Pick<QualificationJSON, '_id'>) => {
      const result = await apiFetch<QualificationJSON>(null, 'corp-api/scalers/qualifications', {
        method: 'PUT',
        body: {
          updatedQualification: qualification,
        },
      });

      return result;
    },
    {
      onSuccess,
      onError: (err: HTTPError) => defaultApiFetchErrorHandler(err, { handleHttp: true }),
    },
  );
};
